import { z } from "zod";

export const IntroReadyMessage = z.object({
    type: z.literal("intro.ready"),
});
export type IntroReadyMessage = z.infer<typeof IntroReadyMessage>;

export const IntroPrimaryActionMessage = z.object({
    type: z.literal("intro.primaryAction"),
});
export type IntroPrimaryActionMessage = z.infer<typeof IntroPrimaryActionMessage>;

export const IntroSecondaryActionMessage = z.object({
    type: z.literal("intro.secondaryAction"),
});
export type IntroSecondaryActionMessage = z.infer<typeof IntroSecondaryActionMessage>;

export const IntroMessage = z.discriminatedUnion("type", [
    IntroReadyMessage,
    IntroPrimaryActionMessage,
    IntroSecondaryActionMessage,
]);
export type IntroMessage = z.infer<typeof IntroMessage>;

/** Sent by the host so the intro drops the pending state of its buttons. */
export const IntroResetMessage = z.object({
    type: z.literal("intro.reset"),
});
export type IntroResetMessage = z.infer<typeof IntroResetMessage>;

export const EligibilityReadyMessage = z.object({
    type: z.literal("eligibility.ready"),
});
export type EligibilityReadyMessage = z.infer<typeof EligibilityReadyMessage>;

export const EligibilityVerifiedMessage = z.object({
    type: z.literal("eligibility.verified"),
});
export type EligibilityVerifiedMessage = z.infer<typeof EligibilityVerifiedMessage>;

/** Registration is complete; the host continues to login with the phone number. */
export const EligibilitySendCodeMessage = z.object({
    type: z.literal("eligibility.sendCode"),
    phoneNumber: z.string().min(1),
});
export type EligibilitySendCodeMessage = z.infer<typeof EligibilitySendCodeMessage>;

export const EligibilityOpenEmailMessage = z.object({
    type: z.literal("eligibility.openEmail"),
});
export type EligibilityOpenEmailMessage = z.infer<typeof EligibilityOpenEmailMessage>;

/** The member backed out of the first eligibility step. */
export const EligibilityCloseMessage = z.object({
    type: z.literal("eligibility.close"),
});
export type EligibilityCloseMessage = z.infer<typeof EligibilityCloseMessage>;

export const EligibilityMessage = z.discriminatedUnion("type", [
    EligibilityReadyMessage,
    EligibilityVerifiedMessage,
    EligibilitySendCodeMessage,
    EligibilityOpenEmailMessage,
    EligibilityCloseMessage,
]);
export type EligibilityMessage = z.infer<typeof EligibilityMessage>;

export function parseIntroMessageData(data: unknown): IntroMessage | null {
    const parsed = IntroMessage.safeParse(data);
    return parsed.success ? parsed.data : null;
}

export function parseIntroResetMessageData(data: unknown): IntroResetMessage | null {
    const parsed = IntroResetMessage.safeParse(data);
    return parsed.success ? parsed.data : null;
}

export function parseEligibilityMessageData(data: unknown): EligibilityMessage | null {
    const parsed = EligibilityMessage.safeParse(data);
    return parsed.success ? parsed.data : null;
}
